import { useSelector } from 'react-redux';
import type { RootState } from '../grid/reduxStore/Store';

export const useBlockLockStatus = (blockId: string) => {
  const blockStyle = useSelector((state: RootState) => (blockId ? state.blockStyleSettings.blockStyle[blockId] : null));

  return {
    isLocked: !!blockStyle?.lockedBy,
    lockedBy: blockStyle?.lockedBy || null,
  };
};
